import { render, staticRenderFns } from "./PerformanceInfo.vue?vue&type=template&id=311a2be4"
import script from "./PerformanceInfo.vue?vue&type=script&lang=js"
export * from "./PerformanceInfo.vue?vue&type=script&lang=js"
import style0 from "./PerformanceInfo.vue?vue&type=style&index=0&id=311a2be4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports